var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minisite-video-container",style:(_vm.getVideoStyle)},[_c('div',{ref:"renderVideo",staticClass:"cv-mb-4 cv-w-full cv-h-auto",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }